<template>
  <div :class="active ? '' : 'hidden'" class="flex flex-col items-center">
    <div class="text-qwray Text">
      {{ $t('payment_methods.charging_card.description1') }}
    </div>
    <article class="ImageGrid">
      <div v-for="(data, index) of images" :key="index">
        <picture>
          <source
            type="image/webp"
            :srcset="require(`@/` + data.sources.webp)"
          />
          <img
            class="LogoImage"
            :src="require(`@/` + data.sources.png)"
            :alt="data.alt"
          />
        </picture>
      </div>
    </article>
    <div
      class="text-qwray Text px-6 mt-10 bg-qwellow rounded-full py-2 cursor-pointer invisible"
    >
      {{ $t('payment_methods.charging_card.button') }}
    </div>
  </div>
</template>

<script>
import { entity } from '@/../region.json';
import images from '@/data/logos.json';

export default {
  props: ['active', 'isMobile'],
  data() {
    return {
      images: images
        .filter(logo => logo.entity.includes(entity))
        .sort((a, b) => a.rank[entity] - b.rank[entity]),
      entity,
    };
  },
};
</script>

<style scoped>
.Parent {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80px;
}

.Text {
  font-size: 14px;
}

@media (min-width: 768px) {
  .Parent {
    height: 115px;
  }
  .Text {
    font-size: 16px;
  }
}
@media (min-width: 1400px) {
  .Text {
    font-size: 18px;
  }
}

@media (min-width: 1600px) {
  .Text {
    font-size: 20px;
  }
}

.MinSize {
  max-width: 25%;
}
.LastElement {
  max-width: 33%;
}
.Image {
  max-height: 100% !important;
  max-width: auto !important;
}
.aTag {
  max-height: 100%;
  height: 100%;
}

.ImageGrid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(92px, 1fr));
  width: 100%;
  column-gap: 20px;
}
.LogoImage {
  max-height: 100% !important;
  max-width: 100% !important;
  height: auto !important;
  min-width: 100% !important;
}
@media (min-width: 1024px) {
  .ImageGrid {
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    column-gap: 16px;
  }
}
</style>
